import React, { useMemo, useState } from "react";
import { IconExclamation } from "../Layout/Icons";
import { prettyDateFormat } from "../../helpers/Utils";
import { removeDuplicates } from "../../helpers/array";

// Failed export attempts for one product, grouped by the rule that produced them.
// Shared so the Retail pricing screen does not have to reach into ImumToAkeneoScreen internals.
const ExportFailures = ({ logs = [] }) => {
  const [showMore, setShowMore] = useState(false);

  const groups = useMemo(() => {
    // Newest first, without mutating the prop array (Array#reverse is in place).
    const newestFirst = [...logs].reverse();
    return removeDuplicates(newestFirst.map(({ title }) => title)).map(
      (title) => {
        const errors = [];
        newestFirst
          .filter((log) => log.title == title)
          .forEach((log) => {
            const duplicate = errors.find(
              (seen) =>
                seen.created_at?.substr(0, 16) == log.created_at?.substr(0, 16) &&
                seen.error == log.error
            );
            if (!duplicate) errors.push(log);
          });
        return { title, errors };
      }
    );
  }, [logs]);

  return (
    <div style={{ minWidth: 180, maxWidth: 240 }}>
      {groups.map((group, idx) =>
        idx > 0 && !showMore ? null : (
          <div key={group.title} className="mb-1">
            <div className="d-flex align-items-center mb-1">
              <IconExclamation className="text-danger mr-1 text-base" />
              <span className="text-base" style={{ lineHeight: "14px" }}>
                {group.title}
              </span>
            </div>
            {group.errors.map((error) => (
              <React.Fragment key={`${error.created_at}_${error.error}`}>
                <p
                  className="text-silver text-sm mb-0"
                  style={{ lineHeight: "14px" }}
                >
                  {error.department ? `${error.department} · ` : ""}
                  {error.created_at && prettyDateFormat(error.created_at)}
                </p>
                <p className="text-sm mb-1" style={{ lineHeight: "14px" }}>
                  {error.error}
                </p>
              </React.Fragment>
            ))}
          </div>
        )
      )}
      {groups.length > 1 && (
        <div
          className="d-flex align-items-center text-primary text-sm cursor-pointer mt-1"
          onClick={() => setShowMore((prev) => !prev)}
        >
          <svg
            className="mr-1"
            xmlns="http://www.w3.org/2000/svg"
            width={18}
            height={18}
            viewBox="0 0 13 13"
            fill="none"
          >
            <path
              d="M6.50004 11.9166C9.49166 11.9166 11.9167 9.49154 11.9167 6.49992C11.9167 3.50829 9.49166 1.08325 6.50004 1.08325C3.50842 1.08325 1.08337 3.50829 1.08337 6.49992C1.08337 9.49154 3.50842 11.9166 6.50004 11.9166Z"
              stroke="#03B0F7"
              strokeWidth="1.08333"
              strokeLinejoin="round"
            />
            {!showMore ? (
              <path
                d="M8.9375 5.6875L6.5 8.125L4.0625 5.6875"
                stroke="#03B0F7"
                strokeWidth="1.08333"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            ) : (
              <path
                d="M4.0625 7.3125L6.5 4.875L8.9375 7.3125"
                stroke="#03B0F7"
                strokeWidth="1.08333"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            )}
          </svg>
          {!showMore ? "Show more failures" : "Show less failures"}
        </div>
      )}
    </div>
  );
};

export default ExportFailures;
